import { AbstractControl, ValidationErrors } from '@angular/forms';

export class DynamicFormValidators {

    static INTEGER_NUMBER_REGEX = new RegExp('^[1-9](\\d+)?$');
    static TWO_DECIMAL_NUMBER_REGEX = new RegExp('^\\d+\\.?\\d{0,2}$');

    static integerNumber(control: AbstractControl): ValidationErrors | null {
        return DynamicFormValidators.INTEGER_NUMBER_REGEX.test(control.value) ? null : {'integerNumber': true};
    }

    static twoDecimalNumber(control: AbstractControl): ValidationErrors | null {
        return DynamicFormValidators.TWO_DECIMAL_NUMBER_REGEX.test(control.value) ? null : {'twoDecimalNumber': true};
    }

    static dateInPast(control: AbstractControl): ValidationErrors | null {
        const value = (control.value instanceof Date) ? control.value : new Date(control.value);
        const now = new Date();
        if (value >= now) {
            return {'dateInPast': true};
        }
        return null;
    }

    static dateInFuture(control: AbstractControl): ValidationErrors | null {
        const value = (control.value instanceof Date) ? control.value : new Date(control.value);
        const now = new Date();
        if (value <= now) {
            return {'dateInFuture': true};
        }
        return null;
    }
}
